import { useRef } from "react";

/** A drag or a scroll that ends over a row is not a click. */
export function usePressWithoutScroll(onPress) {
  const start = useRef(null);

  const onPointerDown = (event) => {
    const scroller = event.currentTarget.closest(
      ".v2-drawer-section-body.is-capped, .v2-drawer-scroll, .v2-left-panel-scroll, .v2-section-list"
    );
    start.current = {
      x: event.clientX,
      y: event.clientY,
      top: scroller ? scroller.scrollTop : 0,
      scroller,
    };
  };

  const onClick = (event) => {
    const origin = start.current;
    if (origin) {
      const moved = Math.hypot(event.clientX - origin.x, event.clientY - origin.y) > 8;
      const scrolled = origin.scroller && Math.abs(origin.scroller.scrollTop - origin.top) > 4;
      if (moved || scrolled) return;
    }
    onPress(event);
  };

  return { onPointerDown, onClick };
}
